module.exports = {
  locales: ['en'],
  defaultLocale: 'en',
  defaultNS: 'common',
  nsSeparator: '|',
  pages: {
    '*': ['common'],
    '/': ['landing'],
    '/filgram': ['home'],
    '/filgram/explore': ['explore', 'storage-provider', 'data-center'],
    '/filgram/data-center/[slug]': ['explore', 'storage-provider', 'data-center'],
    '/filgram/storage-provider/[slug]': ['explore', 'storage-provider', 'data-center', 'dashboard'],
    '/filgram/privacy-policy': ['privacy-policy'],
    '/filgram/faq': ['faq'],
    '/filgram/dashboard/my-profiles': [
      'dashboard',
      'storage-provider',
      'data-center',
    ],
    '/filgram/dashboard/my-profiles/[slug]': [
      'dashboard',
      'storage-provider',
      'data-center',
      'explore'
    ],
    '/filgram/dashboard/filmine': ['dashboard'],
    '/filgram/dashboard/my-deals': ['dashboard', 'common', 'explore'],
    '/filgram/dashboard/connected-addresses': ['dashboard', 'common'],
    '/filgram/dashboard/my-files': ['dashboard'],
    '/filgram/dashboard/account-settings': ['dashboard'],
    '/filgram/dashboard/messages': ['dashboard', 'common', 'explore'],
    '/filgram/dashboard/how-to/store': ['how-to', 'common', 'dashboard'],
    '/filgram/dashboard/how-to/retrieve': ['how-to', 'common', 'dashboard'],
    '/filgram/dashboard/how-to/listing': ['how-to', 'common', 'dashboard'],
    '/filgram/dashboard/how-to/connecting-your-miners': ['how-to', 'common', 'dashboard'],
    '/filgram/dashboard/how-to/miners-dashboard': ['how-to', 'common', 'dashboard'],
    '/filgram/dashboard/how-to/api-reference': ['how-to', 'common', 'dashboard'],
    '/filstation': ['filstation'],
  },
};
